const DAY_VIEW_DAY_WIDTH = 1000;
const WEEK_VIEW_DAY_WIDTH = 100;
const MONTH_VIEW_DAY_WIDTH = 50;

export const ZOOM_LEVEL = {
    day: 0,
    week: 1,
    month: 2,
};

export const ZOOM_SETTINGS = {
    0: {
        // Default amount of days/weeks/months to show
        amountToShow: 1,
        // Default height of itemRow
        rowHeight: 50,
        // Minium height of slot
        minSlotHeight: 5,
        // Height of slot per hour
        hourHeight: 5,
        // Width of days
        dayWidth: {
            1: DAY_VIEW_DAY_WIDTH,
            2: DAY_VIEW_DAY_WIDTH,
            3: DAY_VIEW_DAY_WIDTH,
            4: DAY_VIEW_DAY_WIDTH,
            5: DAY_VIEW_DAY_WIDTH,
            6: DAY_VIEW_DAY_WIDTH,
            7: DAY_VIEW_DAY_WIDTH,
        },
    },
    1: {
        // Default amount of days/weeks/months to show
        amountToShow: 2,
        // Default height of itemRow
        rowHeight: 50,
        // Capacity row height
        capacityRowHeight: 25,
        // Minium height of slot
        minSlotHeight: 15,
        // Height of slot per hour
        hourHeight: 10,
        // Width of days
        dayWidth: {
            1: WEEK_VIEW_DAY_WIDTH,
            2: WEEK_VIEW_DAY_WIDTH,
            3: WEEK_VIEW_DAY_WIDTH,
            4: WEEK_VIEW_DAY_WIDTH,
            5: WEEK_VIEW_DAY_WIDTH,
            6: WEEK_VIEW_DAY_WIDTH,
            7: WEEK_VIEW_DAY_WIDTH,
        },
    },
    2: {
        // Default amount of days/weeks/months to show
        amountToShow: 2,
        // Default height of itemRow
        rowHeight: 50,
        // Capacity row height
        capacityRowHeight: 25,
        // Minium height of slot
        minSlotHeight: 3,
        // Height of slot per hour
        hourHeight: 5,
        // Width of days
        dayWidth: {
            1: MONTH_VIEW_DAY_WIDTH,
            2: MONTH_VIEW_DAY_WIDTH,
            3: MONTH_VIEW_DAY_WIDTH,
            4: MONTH_VIEW_DAY_WIDTH,
            5: MONTH_VIEW_DAY_WIDTH,
            6: MONTH_VIEW_DAY_WIDTH,
            7: MONTH_VIEW_DAY_WIDTH,
        },
    },
};

export const MODE = {
    project: {
        title: 'Task',
        route: 'planning.tasks',
        linkRoute: 'project.task.show',
        type: 'planning',
        sort: {
            nameAsc: {
                title: 'Project title',
                subTitle: 'A-Z',
                sort: 'project-title',
                sortOrder: 'ASC',
                default: true,
                route: 'project.show',
            },
            nameDesc: {
                title: 'Project title',
                subTitle: 'Z-A',
                sort: 'project-title',
                sortOrder: 'DESC',
                default: false,
                route: 'project.show',
            },
            deadlineAsc: {
                title: 'Project deadline',
                subTitle: 'Closest-Latest',
                sort: 'project-deadline_at',
                sortOrder: 'ASC',
                default: false,
                route: 'project.show',
            },
            deadlineDesc: {
                title: 'Project deadline',
                subTitle: 'Latest-Closest',
                sort: 'project-deadline_at',
                sortOrder: 'DESC',
                default: false,
                route: 'project.show',
            },
        },
    },
    person: {
        title: 'Person',
        route: 'planning.persons',
        linkRoute: 'person.show',
        type: 'planning',
        sort: {
            nameAsc: {
                title: 'Name',
                subTitle: 'A-Z',
                sort: 'last_name',
                sortOrder: 'ASC',
                default: false,
                route: null,
            },
            nameDesc: {
                title: 'Name',
                subTitle: 'Z-A',
                sort: 'last_name',
                sortOrder: 'DESC',
                default: false,
                route: null,
            },
            teamManual: {
                title: 'Team manual',
                subTitle: '',
                sort: 'team-order',
                sortOrder: 'ASC',
                default: false,
                route: 'team.show',
            },
            teamAsc: {
                title: 'Team',
                subTitle: 'A-Z',
                sort: 'team-title',
                sortOrder: 'ASC',
                default: false,
                route: 'team.show',
            },
            teamDesc: {
                title: 'Team',
                subTitle: 'Z-A',
                sort: 'team-title',
                sortOrder: 'DESC',
                default: false,
                route: 'team.show',
            },
            departmentAsc: {
                title: 'Department',
                subTitle: 'A-Z',
                sort: 'department-title',
                sortOrder: 'ASC',
                default: false,
                route: null,
            },
            departmentDesc: {
                title: 'Department',
                subTitle: 'Z-A',
                sort: 'department-title',
                sortOrder: 'DESC',
                default: false,
                route: null,
            },
            manual: {
                title: 'Manual',
                subTitle: '',
                sort: 'order',
                sortOrder: 'ASC',
                default: true,
                route: null,
            },
        },
    },
    team: {
        title: 'Team',
        route: 'planning.teams',
        linkRoute: 'team.show',
        type: 'planning',
        sort: {
            titleAsc: {
                title: 'Name',
                subTitle: 'A-Z',
                sort: 'title',
                sortOrder: 'ASC',
                default: false,
                route: null,
            },
            titleDesc: {
                title: 'Name',
                subTitle: 'Z-A',
                sort: 'title',
                sortOrder: 'DESC',
                default: false,
                route: null,
            },
            manual: {
                title: 'Manual',
                subTitle: '',
                sort: 'order',
                sortOrder: 'ASC',
                default: true,
                route: null,
            },
        },
    },
    equipment: {
        title: 'Equipment',
        route: 'planning.equipments',
        linkRoute: 'equipment.show',
        type: 'planning',
        sort: {
            titleAsc: {
                title: 'Title',
                subTitle: 'A-Z',
                sort: 'title',
                sortOrder: 'ASC',
                default: true,
                route: null,
            },
            titleDesc: {
                title: 'Title',
                subTitle: 'Z-A',
                sort: 'title',
                sortOrder: 'DESC',
                default: false,
                route: null,
            },
        },
    },
    capacityPerson: {
        title: 'Person',
        route: 'planning.persons',
        linkRoute: 'person.show',
        type: 'capacity',
        sort: {
            nameAsc: {
                title: 'Name',
                subTitle: 'A-Z',
                sort: 'last_name',
                sortOrder: 'ASC',
                default: false,
                route: null,
            },
            nameDesc: {
                title: 'Name',
                subTitle: 'Z-A',
                sort: 'last_name',
                sortOrder: 'DESC',
                default: false,
                route: null,
            },
            teamManual: {
                title: 'Team manual',
                subTitle: '',
                sort: 'team-order',
                sortOrder: 'ASC',
                default: false,
                route: 'team.show',
            },
            teamAsc: {
                title: 'Team',
                subTitle: 'A-Z',
                sort: 'team-title',
                sortOrder: 'ASC',
                default: false,
                route: 'team.show',
            },
            teamDesc: {
                title: 'Team',
                subTitle: 'Z-A',
                sort: 'team-title',
                sortOrder: 'DESC',
                default: false,
                route: 'team.show',
            },
            departmentAsc: {
                title: 'Department',
                subTitle: 'A-Z',
                sort: 'department-title',
                sortOrder: 'ASC',
                default: false,
                route: null,
            },
            departmentDesc: {
                title: 'Department',
                subTitle: 'Z-A',
                sort: 'department-title',
                sortOrder: 'DESC',
                default: false,
                route: null,
            },
            manual: {
                title: 'Manual',
                subTitle: '',
                sort: 'order',
                sortOrder: 'ASC',
                default: true,
                route: null,
            },
        },
    },
    dailyPlanned: {
        title: 'Day tasks',
        route: 'planning.tasks',
        linkRoute: 'project.task.show',
        type: 'planning',
        sort: {
            idAsc: {
                title: 'Creatie tijdstip',
                subTitle: 'oldest - newest',
                sort: 'id',
                sortOrder: 'ASC',
                default: true,
                route: null,
            },
        },
    },
    projectPersons: {
        title: 'Project persons',
        route: 'planning.tasks',
        linkRoute: 'project.task.show',
        type: 'planning',
        sort: {
            idAsc: {
                title: 'Creatie tijdstip',
                subTitle: 'oldest - newest',
                sort: 'id',
                sortOrder: 'ASC',
                default: true,
                route: null,
            },
        },
    },
    teamLead: {
        title: 'Team lead',
        route: '',
        linkRoute: '',
        type: 'planning',
        sort: {},
    },
};

export const DEFAULT_FILTER = {
    filter: {
        name: '',
        free: null,
        skills: [],
        certificate_ids: [],
        job_ids: [],
        department_ids: [],
        team_ids: []
    },
    sort: 'order',
}